import React from 'react';
import { motion } from 'framer-motion';
const timeline = [{
  company: 'Genentech (Roche)',
  period: '2025 to Present'
}, {
  company: 'Walmart',
  period: '2023 to 2025'
}, {
  company: 'Amazon',
  period: '2021 to 2023'
}, {
  company: 'Enfusion',
  period: '2018 to 2021'
}, {
  company: 'Spark Capital / JM Financial',
  period: '2014 to 2016'
}];
export function About() {
  return <section id="about" className="py-24 md:py-32 border-t border-border" data-id="element-11">
      <div className="max-w-6xl mx-auto px-6 md:px-12" data-id="element-12">
        <div className="mb-16" data-id="element-13">
          <h2 className="text-2xl md:text-3xl font-semibold text-primary tracking-tight" data-id="element-14">
            About
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16" data-id="element-15">
          {/* Bio & Timeline */}
          <div className="lg:col-span-7" data-id="element-16">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            duration: 0.6
          }} className="space-y-6 text-lg text-secondary leading-relaxed mb-16" data-id="element-17">
              <p data-id="element-18">
                I am an AI product leader who specializes in the systems that
                sit between models and decisions. Over the past decade, I have
                built measurement platforms, recommendation engines, and risk
                systems across pharma, retail, e-commerce, and institutional
                finance.
              </p>
              <p data-id="element-19">
                At Genentech, I built a ~40-person cross-functional org from
                scratch and own the enterprise platform governing $1.2B+ in
                marketing allocation. Before that, I drove $4.5B in GMV
                decisions at Walmart, led recommendation systems serving ~1B
                daily inferences at Amazon, and built AI risk platforms for
                $200B+ in assets at Enfusion.
              </p>
              <p data-id="element-20">
                I started my career in investment banking at Spark Capital and
                JM Financial, where I learned how nine-figure capital allocation
                decisions actually get made. That experience shapes everything I
                build today.
              </p>
            </motion.div>

            <div className="relative" data-id="element-21">
              <div className="absolute left-[7px] top-2 bottom-2 w-px bg-border" data-id="element-22" />
              <div className="space-y-8" data-id="element-23">
                {timeline.map((item, index) => <motion.div key={index} initial={{
                opacity: 0,
                x: -20
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true,
                margin: '-100px'
              }} transition={{
                duration: 0.5,
                delay: index * 0.1
              }} className="relative pl-10" data-id="element-24">
                    <div className="absolute left-0 top-1.5 w-4 h-4 rounded-full bg-dark border-2 border-border flex items-center justify-center" data-id="element-25">
                      <div className="w-1.5 h-1.5 rounded-full bg-gold" data-id="element-26" />
                    </div>
                    <div className="flex flex-col sm:flex-row sm:items-baseline gap-1 sm:gap-4" data-id="element-27">
                      <h3 className="text-base font-semibold text-primary tracking-tight" data-id="element-28">
                        {item.company}
                      </h3>
                      <span className="text-sm text-secondary font-medium" data-id="element-29">
                        {item.period}
                      </span>
                    </div>
                  </motion.div>)}
              </div>
            </div>
          </div>

          {/* Pull Quote */}
          <div className="lg:col-span-5 flex items-start lg:items-center" data-id="element-30">
            <motion.div initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} className="glass-card p-8 md:p-10 rounded-2xl sticky top-32" data-id="element-31">
              <blockquote className="text-xl md:text-2xl text-primary leading-relaxed font-medium tracking-tight" data-id="element-32">
                "I kept following the same question: how do organizations
                actually make better decisions with AI? Into progressively
                higher-stakes environments."
              </blockquote>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}